import { Injectable } from '@angular/core';

import { BetslipPick } from '../../../../../core/picks/betslip-pick';
import { BetslipUnknownPick } from '../../../../../core/picks/betslip-unknown-pick';
import { PickOddsState } from '../../../../../core/picks/pick-models';
import { PickLockedPreCheckError } from '../../../errors/pre-check/pick-locked-pre-check-error';
import { IPurePickValidator } from './validators';

@Injectable()
export class PickLockedValidator implements IPurePickValidator<PickLockedPreCheckError> {
    validate(pick: BetslipPick): PickLockedPreCheckError[] {
        if (!BetslipUnknownPick.isPick(pick) && pick.oddsState === PickOddsState.Locked) {
            return [new PickLockedPreCheckError(pick.id.toString())];
        }

        return [];
    }
}
